import { useState, useCallback, useEffect, useRef } from "react";
import { NAVBAR_ASSETS } from "../constants/assets";

const { logo, logoWhite } = NAVBAR_ASSETS;

export const useNavbarScroll = (isTransparent: boolean) => {
  const [navbarLogo, setNavbarLogo] = useState(isTransparent ? logoWhite : logo);
  const [isScrolled, setIsScrolled] = useState(false);
  const throttleRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleScroll = useCallback(() => {
    if (throttleRef.current) clearTimeout(throttleRef.current);
    throttleRef.current = setTimeout(() => {
      const scrollY = window.scrollY;
      if (isTransparent) {
        setIsScrolled(scrollY > 50);
        setNavbarLogo(scrollY <= 66 ? logoWhite : logo);
      } else {
        setIsScrolled(false);
        setNavbarLogo(logo);
      }
    }, 16);
  }, [isTransparent]);

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (throttleRef.current) clearTimeout(throttleRef.current);
    };
  }, [handleScroll]);

  return { navbarLogo, isScrolled };
};
